/*
 * @Author: your name
 * @Date: 2019-08-01 09:37:32
 * @LastEditTime: 2019-12-07 11:06:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xinsec-new-security-vue\src\api\index.js
 */

import app from '@/apis/modules/app.js'; // 应用接口
import nav from '@/apis/modules/nav.js'; // 导航接口
import third from '@/apis/modules/third.js'; // 导航接口

const API = {
  app,
  nav,
  third
};

export default API;
